module.exports = __webpack_public_path__ + "static/media/VideoSite01.4409773.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/VideoSite01.mp4
// module id = B+Tj
// module chunks = 1